import type { IComment } from "../../../../../types/comment";

export const handleCheckToggle = (
  comment: IComment,
  checkedCommentsID: string[],
  setCheckedCommentsID: React.Dispatch<React.SetStateAction<string[]>>
) => {
  if (checkedCommentsID.some((id) => id === comment.id)) {
    removeCommentToChecked(comment.id, checkedCommentsID, setCheckedCommentsID);
  } else {
    addCommentToChecked(comment.id, setCheckedCommentsID, checkedCommentsID);
  }
};

const removeCommentToChecked = (
  id: string,
  checkedCommentsID: string[],
  setCheckedCommentsID: React.Dispatch<React.SetStateAction<string[]>>
) => {
  const newCheckedComments = checkedCommentsID.filter(
    (commentID) => commentID !== id
  );
  setCheckedCommentsID([...newCheckedComments]);
};

const addCommentToChecked = (
  id: string,
  setCheckedCommentsID: React.Dispatch<React.SetStateAction<string[]>>,
  checkedCommentsID: string[]
) => {
  setCheckedCommentsID([...checkedCommentsID, id]);
};
